export default {
  computed: {
    queryParams() {
      let query = new URLSearchParams(document.location.search.substring(1))
      return Object.fromEntries(query.entries())
    }
  },

  methods: {
    queryParam(param, defaultValue = null) {
      let params = new URLSearchParams(document.location.search.substring(1))
      return params.get(param) || defaultValue
    }
  }
}
